import { getDateTimeParts } from "./get-date-time-parts.mjs";
import { isSameMonth } from "./is-same-month.mjs";
export function isSameDay(date1, date2, timeZone) {
  var _getDateTimeParts = getDateTimeParts(date1, timeZone),
    day1 = _getDateTimeParts.day;
  var _getDateTimeParts2 = getDateTimeParts(date2, timeZone),
    day2 = _getDateTimeParts2.day;
  return isSameMonth(date1, date2, timeZone) && day1() === day2();
}